import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { RuntimeConfiguration } from '@/configuration';
import { useWalletDetails } from '../providers/WalletDetailsProvider';
import { getNetworkName } from '../utils/getChainId.utils';
import { truncateAddress } from '../utils/truncateAddress.utils';

export interface TokenDetailsContainerProps {
  price: string;
}

const TokenDetailsContainer = ({ price }: TokenDetailsContainerProps) => {
  const theme = useTheme();
  const { walletDetails } = useWalletDetails();

  const networkName = useMemo(() => {
    return getNetworkName(+RuntimeConfiguration.CHAIN_ID);
  }, []);

  return (
    <Box
      sx={{
        padding: {
          xs: '8px',
          sm: '8px',
          md: '16px',
          lg: '16px'
        },
        background: theme?.palette?.secondary?.light,
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
        borderRadius: '4px',
        marginTop: '16px',
        marginBottom: '20px'
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 500,
            color: theme?.ClaimTemplate?.collectionHeaderColor,
            fontFamily: theme?.MojitoClaim?.font?.tertiary
          }}
        >
          Wallet Address
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            color: theme?.MojitoClaim?.textTertiary,
            fontFamily: theme?.MojitoClaim?.font?.tertiary
          }}
        >
          {truncateAddress(walletDetails.address)}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 500,
            color: theme?.ClaimTemplate?.collectionHeaderColor,
            fontFamily: theme?.MojitoClaim?.font?.tertiary
          }}
        >
          Network
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            color: theme?.MojitoClaim?.textTertiary,
            fontFamily: theme?.MojitoClaim?.font?.tertiary
          }}
        >
          {networkName}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 500,
            color: theme?.ClaimTemplate?.collectionHeaderColor,
            fontFamily: theme?.MojitoClaim?.font?.tertiary
          }}
        >
          Price
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            color: theme?.MojitoClaim?.textTertiary,
            fontFamily: theme?.MojitoClaim?.font?.secondary
          }}
        >{`${Number(price).toFixed(5)} ETH`}</Typography>
      </Stack>
    </Box>
  );
};

export default TokenDetailsContainer;
